import React from "react";
import { Grid, Typography, WithStyles } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { useAuthContext } from "../../auth/AuthProvider";
import { BlueButton } from "../components/Buttons/BlueButton";
import { useHistory } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import { styles } from "./SignInOrRegisterView.styles";
import { CenteredContainer } from "../components/CenteredContainer/CenteredContainer";

export interface ISignInOrRegisterViewProps extends WithStyles<typeof styles> {}

export const SignInOrRegisterViewPure: React.FunctionComponent<ISignInOrRegisterViewProps> = ({
    classes
}: ISignInOrRegisterViewProps) => {
    const authContext = useAuthContext();
    const history = useHistory();
    const { t } = useTranslation();

    return (
        <CenteredContainer>
            <Grid container spacing={5}>
                <Grid item xs={6}>
                    <Typography variant="h4">{t("signInOrRegister.newCustomer")}</Typography>
                    <p className={classes.description}>{t("signInOrRegister.newCustomerDesc")}</p>
                    <BlueButton onClick={() => history.push("/register")}>{t("general.register")}</BlueButton>
                </Grid>
                <Grid item xs={6}>
                    <Typography variant="h4">{t("signInOrRegister.returningCustomer")}</Typography>
                    <p className={classes.description}>{t("signInOrRegister.logInDesc")}</p>
                    <BlueButton onClick={() => authContext.requestAuth()}>{t("signInOrRegister.logIn")}</BlueButton>
                </Grid>
            </Grid>
        </CenteredContainer>
    );
};

export const SignInOrRegisterView = withStyles(styles)(SignInOrRegisterViewPure);
